module.exports = __webpack_public_path__ + "static/media/sideBarToggleOpen.e389603b.svg";